// extracted by mini-css-extract-plugin
export default {"container":"PQ-z","darkBackground":"QQ-z","whiteBackground":"RQ-z","headerButton":"SQ-z","calloutHeading":"TQ-z","calloutSubHeading":"UQ-z"};